import { Injectable } from '@angular/core';
import { Router, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class DeactivateFormGuard implements CanDeactivate<any> {

    constructor(private router: Router) { }

    canDeactivate(component: any) {
        return component.canDeactivate ? component.canDeactivate() : true;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/route-control/deactivate-form.guard.ts